import type { NativeToolbarMenuActionProps, NativeToolbarMenuProps } from './types';

export const NativeToolbarMenu: React.FC<NativeToolbarMenuProps> = () => null;

export const NativeToolbarMenuAction: React.FC<NativeToolbarMenuActionProps> = () => null;
